import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Briefcase, Rocket, Sparkles } from 'lucide-react';

const CTASection = () => {
  return (
    <section id="cta" className="relative py-24 lg:py-32 overflow-hidden">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.8 }}
          className="relative rounded-[2rem] overflow-hidden"
          style={{
            background: 'linear-gradient(135deg, rgba(30, 80, 200, 0.15), rgba(255, 140, 50, 0.12))',
            border: '1px solid rgba(255,255,255,0.08)',
            backdropFilter: 'blur(20px)',
          }}
        >
          {/* Animated background blobs */}
          <div className="absolute inset-0 overflow-hidden pointer-events-none">
            <motion.div
              animate={{ x: [0, 100, 0], y: [0, 50, 0] }}
              transition={{ duration: 14, repeat: Infinity, ease: 'easeInOut' }}
              className="absolute -top-40 -left-20 w-[500px] h-[500px] bg-[#4facfe]/30 rounded-full blur-3xl"
            />
            <motion.div
              animate={{ x: [0, -100, 0], y: [0, -50, 0] }}
              transition={{ duration: 18, repeat: Infinity, ease: 'easeInOut' }}
              className="absolute -bottom-40 -right-20 w-[500px] h-[500px] bg-[#ffa726]/25 rounded-full blur-3xl"
            />
            <div className="absolute inset-0 grid-pattern opacity-30" />
          </div>

          <div className="relative z-10 px-6 sm:px-12 lg:px-16 py-14 lg:py-20 text-center">
            <motion.span
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              className="eyebrow"
            >
              <Sparkles size={14} /> Começa em menos de 2 minutos
            </motion.span>

            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: 0.1 }}
              className="mt-6 heading-display text-4xl sm:text-5xl lg:text-6xl text-white"
            >
              Seu próximo investimento{' '}<br />
              <span className="gradient-text">pode começar aqui.</span>
            </motion.h2>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: 0.2 }}
              className="mt-6 text-base sm:text-lg text-slate-300 max-w-2xl mx-auto leading-relaxed"
            >
              Junte-se a investidores e empreendedores criando oportunidades reais.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: 0.3 }}
              className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4"
            >
              <Link
                to="/auth?signup=1&role=investor"
                data-testid="footer-cta-investor"
                className="btn-gold rounded-2xl px-7 py-4 text-sm inline-flex items-center gap-2.5 group w-full sm:w-auto justify-center"
              >
                <Briefcase size={16} />
                Quero Investir
                <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
              </Link>
              <Link
                to="/auth?signup=1&role=entrepreneur"
                data-testid="footer-cta-entrepreneur"
                className="btn-primary rounded-2xl px-7 py-4 text-sm inline-flex items-center gap-2.5 group w-full sm:w-auto justify-center"
              >
                <Rocket size={16} />
                Procurar Investidor
                <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
              </Link>
            </motion.div>

            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: 0.5 }}
              className="mt-10 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-slate-400"
            >
              <div className="flex items-center gap-2">
                <div className="w-1.5 h-1.5 rounded-full bg-green-400" /> Cadastro grátis
              </div>
              <div className="flex items-center gap-2">
                <div className="w-1.5 h-1.5 rounded-full bg-green-400" /> Sem complicação
              </div>
              <div className="flex items-center gap-2">
                <div className="w-1.5 h-1.5 rounded-full bg-green-400" /> Suporte humano
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
